import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper, isMobile } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.Origin
const label = 'origin' // visitFilterLabelMap[key] // conforming the existing analytics label

export const originColumn = () =>
  columnHelper.display({
    id: 'origin',
    header: 'Origin',
    cell: ({ row }) => {
      if (isMobile(row.original)) {
        const bundleId = row.original.bundle_id
        const packageName = row.original.package_name
        const origin = bundleId || packageName

        if (!origin) {
          return <Unavailable />
        }

        return (
          <CellAction
            copyValue={origin}
            field={label}
            // Mobile origin search is not yet available.
            search={(old) => ({ ...old, [IdentificationUrlKeys.Url]: origin })}
            className='min-w-36 max-w-72 truncate'
          >
            {origin}
          </CellAction>
        )
      }

      const url = row.original.url

      if (!url) {
        return <Unavailable />
      }

      try {
        const URLObj = new URL(url)
        return (
          <CellAction
            copyValue={url}
            field={label}
            search={(old) => ({ ...old, [key]: URLObj.origin })}
            className='min-w-36 max-w-72 truncate'
          >
            {/* <div className='absolute top-0 left-[var(--spacing-x)] right-[var(--spacing-x)] opacity-0 group-hover/target:opacity-100 flex flex-nowrap gap-2 items-center max-w-full truncate'>
              <Typography size='sm' className='text-nowrap text-gray-600' title={URLObj.origin}>
                {URLObj.protocol}
                {'//'}
              </Typography>
              {URLObj.port ? (
                <Typography size='sm' className='text-nowrap text-gray-600' title={URLObj.origin}>
                  {':'}
                  {URLObj.port}
                </Typography>
              ) : null}
            </div>
            <Typography className='text-nowrap truncate' title={URLObj.origin}>
              {URLObj.hostname}
            </Typography> */}

            {/* Alternative look, simply showing the full origin. */}
            <Typography title={URLObj.origin}>{URLObj.origin}</Typography>
          </CellAction>
        )
      } catch {
        return (
          <CellAction
            copyValue={url}
            field={label}
            search={(old) => ({ ...old, [IdentificationUrlKeys.Url]: url })}
            className='max-w-72 truncate'
          >
            <Typography className='text-nowrap' title={url}>
              {url}
            </Typography>
          </CellAction>
        )
      }
    },
  })
